var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar histories-sidebar"},[_c('div',{staticClass:"filter-search"},[_vm._t("historiesSearch"),_c('RplDivider'),_c('HistoricFilters')],2)])}
var staticRenderFns = []

export { render, staticRenderFns }